<template>
  <div
    id="informModal"
    class="modal fade"
    :class="{ in: isShowModal, active: isShow }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-show="isShow"
  >
    <div class="modal-bg" @click="onModalClose"></div>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="m-logo">
          <img
            src="https://resource.rcclchina.com.cn/Home/new/logo-modal.png"
          />
        </div>
        <div class="m-title">{{ title }}</div>
        <div
          class="common-modal-close"
          data-dismiss="modal"
          aria-label="Close"
          @click="onModalClose"
        >
          <img
            class="common-modal-close"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
          />
        </div>

        <div class="modal-body">
          <div class="parah" v-html="message"></div>
          <a class="m-link" @click="readMessage">我知道了</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import api from "@/api";
import { gioAdsTracking } from "@/utilities/tools";
export default {
  name: "EmergencyMessageAlert",
  data() {
    return {
      isShowModal: false,
      isShow: false,
      message: "",
      title: "",
      link: "",
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.showMessage();
    },
    async showMessage() {
      const { success, data } = await api.page.getEmergencyMessage({
        terminal: "PC"
      });
      if (success && data && data.description) {
        if(data.popupMessageType === '维护弹窗') {
          this.message = data.description;
          this.title = data.title;
          if (data.homeMessageUrl) {
            this.link = data.homeMessageUrl;
          }
          this.isShow = true;
          return;
        }

        const isPopuped = Cookies.get("rcclinformModal", { path: "/" });
        if (isPopuped && isPopuped.length > 0) {
          return;
        }
        this.message = data.description;
        this.title = data.title;
        if (data.homeMessageUrl) {
          this.link = data.homeMessageUrl;
        }
        this.isShow = true;
        Cookies.set("rcclinformModal", data.id, { expires: 1 });
      }
    },
    onModalClose() {
      this.isShowModal = false;
      setTimeout(() => {
        this.isShow = false;
      }, 100);
    },
    readMessage() {
      if (this.link && this.link.length > 0) {
        location.open(this.link);
      }

      this.onModalClose();
			gioAdsTracking({
				"adsType": "pp"
			})
    },
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
    },
  },
};
</script>


<style lang="less" scoped>
.modal-dialog {
  top: 50px;
}

.modal {
  .modal-content {
    min-width: 650px;
    border-radius: 8px;
    position: relative;
    padding-top: 20px;
    box-sizing: border-box;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }

  .common-modal-close {
    position: absolute;
    width: 28px;
    top: 3px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
  }
  .m-logo {
    text-align: center;
  }
  .m-title {
    position: relative;
    left: -3.5%;
    width: 107%;
    height: 56px;
    text-align: center;
    font-size: 26px;
    line-height: 56px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .modal-body {
    padding: 0px 30px 15px 30px;
    .m-link {
      display: block;
      width: 168px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      font-weight: 400;
      color: #282b2c;
      margin: 0 auto;
      background: #fbc500;
      margin-top: 40px;
      cursor: pointer;
    }
  }
}

.modal.active {
  display: block;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>

<style lang="less">
#informModal .modal-body {
  .parah {
    font-size: 14px;
    font-weight: 400;
    color: #282b2c;
    line-height: 26px;
    margin-bottom: 9px;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
</style>